import React from 'react';
// components
import Image, { ImageProps } from '../image/Image';
import { sharedLogosPath } from '../../scripts/data';
import CustomLink from '../custom-link/CustomLink';
import { pageType } from '../../interfaces';

export type HeaderLessProps = {
  loginLink?: string;
  partnerLogo?: ImageProps;
  pageType: pageType;
};

class HeaderLess extends React.PureComponent<HeaderLessProps> {
  render() {
    return (
      <header id="header">
        <div className="container d-flex justify-content-between align-items-center py-2 py-lg-3">
          <CustomLink
            isLink={this.props.pageType === 'product'}
            href="/"
            className="exp-logo d-flex align-items-center">
            <Image
              src={`${sharedLogosPath}/logo-experian.svg`}
              alt="Experian logo."
              width="111"
              height="38"
              className="img-fluid w-100"
            />
          </CustomLink>
          <div className="d-flex align-items-center">
            {this.props.loginLink && (
              <a
                data-link-both="nav-public-header-signin"
                href={this.props.loginLink}
                data-op="LGN"
                className="text-decoration-none text-dark">
                Sign In
              </a>
            )}
            {this.props.partnerLogo && (
              <Image
                {...this.props.partnerLogo}
                className="partner-logo"
              />
            )}
          </div>
        </div>
      </header>
    );
  }
}

export default HeaderLess;
